import template from './billing_category.edit.html'
import controller from './billing_category.edit.controller'
import './billing_category.edit.scss'

const billingCategoryEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billingCategoryEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/edit/billing_category.edit.component.js